import { useSelector } from 'react-redux';
import { selectRespondentProjectVersions } from '@store/selectors';
import { RespondentResponseMetadata } from '../Context';

export const useRespondentVersions = (projectParentId: number, userId: number) => {
  const versions = useSelector(selectRespondentProjectVersions(projectParentId, userId));

  return versions as RespondentResponseMetadata[];
};